import { get, post } from "./ajax";
import { showError } from "./context";
import { gstate } from "./gstate";

export async function ensureSessionExists() {
  await get("/admin/start");
}

export async function isLogin() {
  const result = await get("/admin/isLogin");
  if (result.code !== 0) {
    return false;
  }
  gstate.user = result.data || null;
  return result.code === 0;
}

export async function logout() {
  const res = await post("/admin/logout");
  if (res.code !== 0) {
    showError(res.message);
    return;
  }
  window.location.href = "/login";
}
